import { createSlice } from '@reduxjs/toolkit'
import { RootState } from 'store'

const initialState = {
  modal: { open: false, invalid: false, loading: false, enableSend: 'enable' },
  componentModal: <></>
}

export const counterSlice = createSlice({
  name: 'counter',
  initialState,
  reducers: {
    openModalAction: (state, action) => {
      state.modal.open = action.payload?.isOpen
      state.componentModal = action.payload?.component
    },
    closeModalAction: (state) => {
      state.modal.open = false
      state.componentModal = <></>
    },
    setValidationDataModal: (state, action) => {
      state.modal.invalid = action.payload
    },
    setLoadingModal: (state, action) => {
      state.modal.loading = action.payload
    },
    setEnableSendModal: (state, action) => {
      state.modal.enableSend = action.payload
    }
  }
})

export const {
  openModalAction,
  closeModalAction,
  setValidationDataModal,
  setLoadingModal,
  setEnableSendModal
} = counterSlice.actions
export const commonSelector = (state: RootState) => state.commonReducer
export default counterSlice.reducer
